/**
 * Parent-Teacher Meeting Service - API client for slot publishing/booking
 */
import api from '../utils/api';

const ptmService = {
  // ---- Teacher ----

  createSlot: async (data) => {
    try {
      return await api.post('/api/teacher/ptm/slots', data);
    } catch (error) {
      console.error('Error creating PTM slot:', error);
      throw error;
    }
  },

  listMySlots: async (fromDate = null) => {
    try {
      const params = {};
      if (fromDate) params.from_date = fromDate;
      return await api.get('/api/teacher/ptm/slots', { params });
    } catch (error) {
      console.error('Error fetching PTM slots:', error);
      throw error;
    }
  },

  cancelSlot: async (slotId) => {
    try {
      return await api.delete(`/api/teacher/ptm/slots/${slotId}`);
    } catch (error) {
      console.error('Error cancelling PTM slot:', error);
      throw error;
    }
  },

  listMyTeacherBookings: async () => {
    try {
      return await api.get('/api/teacher/ptm/bookings');
    } catch (error) {
      console.error('Error fetching PTM bookings:', error);
      throw error;
    }
  },

  cancelBookingAsTeacher: async (bookingId, reason = '') => {
    try {
      return await api.post(`/api/teacher/ptm/bookings/${bookingId}/cancel`, { reason });
    } catch (error) {
      console.error('Error cancelling PTM booking:', error);
      throw error;
    }
  },

  // ---- Parent ----

  listOpenSlots: async (teacherId = null, fromDate = null) => {
    try {
      const params = {};
      if (teacherId) params.teacher_id = teacherId;
      if (fromDate) params.from_date = fromDate;
      return await api.get('/api/parent/ptm/slots', { params });
    } catch (error) {
      console.error('Error fetching open PTM slots:', error);
      throw error;
    }
  },

  bookSlot: async (slotId, studentId, purpose = '') => {
    try {
      return await api.post('/api/parent/ptm/bookings', { slot_id: slotId, student_id: studentId, purpose });
    } catch (error) {
      console.error('Error booking PTM slot:', error);
      throw error;
    }
  },

  listMyParentBookings: async () => {
    try {
      return await api.get('/api/parent/ptm/bookings');
    } catch (error) {
      console.error('Error fetching my PTM bookings:', error);
      throw error;
    }
  },

  cancelBookingAsParent: async (bookingId, reason = '') => {
    try {
      return await api.post(`/api/parent/ptm/bookings/${bookingId}/cancel`, { reason });
    } catch (error) {
      console.error('Error cancelling PTM booking:', error);
      throw error;
    }
  },
};

export default ptmService;
